// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__2SbPd","open":"Sidebar_open__uSeyZ"};